/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{ "rawString": ".callout_6bde38cf .ms-Suggestions-itemButton{padding:0;border:none}.callout_6bde38cf .ms-Suggestions{min-width:300px}" }]);
export var callout = "callout_6bde38cf";
//# sourceMappingURL=BaseFloatingPicker.scss.js.map